import '@local/notifications'



// WEBPACK FOOTER //
// ./src/components/bundle/index.js